import { publicUrl } from '../routing/basePath'

export function TourCampaignPanel() {
  return (
    <figure
      aria-label="Proceed With Caution, The Paradox Tour"
      className="tour-campaign-panel"
      data-tour-art-source="fall-2026-tour-poster"
    >
      <div className="tour-campaign-panel__art" aria-hidden="true">
        <img
          alt=""
          decoding="async"
          loading="eager"
          src={publicUrl('assets/the-paradox-fall-tour-flyer-760.png')}
        />
      </div>
      <figcaption>
        <span>Proceed With Caution</span>
        <strong>The Paradox Tour</strong>
        <small>Fall 2026</small>
      </figcaption>
    </figure>
  )
}
